export default __webpack_public_path__ + "static/media/Schedule.44dfb837.png";